import React from 'react'

const Header = () => {
  return (
    <div
      style={{
        textAlign: 'center',
      }}
    >
      {/* <h2>Site Title</h2> */}
    </div>
  )
}

export default Header
